import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';
import type { WalletWidgetContainerProps } from './WalletWidgetContainer.types';

export const WalletWidgetContainer = dynamic(() =>
  import('./WalletWidgetContainer').then(mod => mod.WalletWidgetContainer)
);

export const WalletWidgetContainerSkeleton = dynamic(() =>
  import('./components/WalletWidgetContainerSkeleton').then(mod => mod.WalletWidgetContainerSkeleton)
);

export const WalletWidgetContainerConfig = {
  emptyLabel: 'Wallet Widget Container',
  resourceType: ``,
  isEmpty: () => true,
};

export const WalletWidgetContainerEditable = (props: WalletWidgetContainerProps) => {
  return (
    <EditableComponent config={WalletWidgetContainerConfig} {...props}>
      <WalletWidgetContainer {...props} />
    </EditableComponent>
  );
};

export type { WalletWidgetContainerProps } from './WalletWidgetContainer.types';
export { WalletWidgetContainerContext, useWalletWidgetBadgePublisher } from './WalletWidgetContainerContext';
export type { WalletWidgetContainerContextValue } from './WalletWidgetContainerContext';
export { resolveTierIconColor } from './__utils__';
